export default __webpack_public_path__ + "static/media/demo_image_a-james-donovan-180375.4fa5a365.jpg";